


(function ($) {
    console.log('SCRI theme.js', $);
})(jQuery);
console.log('SCRI js');
$(document).ready(function () {
    closeSearch();
    $("#search").on("input", function (event) {
        $.ajax("https://liveapi.yext.com/v2/accounts/me/answers/autocomplete?api_key=54d95e3acf60def2fb1e2b5acadab75f&v=20180204&experienceKey=ontada-answers&input=" + $("#search-field").val(),
            {
                dataType: 'json', // type of response data
                timeout: 500,     // timeout milliseconds
                success: function (n, status, xhr) {   // success callback function
                    $('.breadcrumb').css('z-index', 0);
                    $('.hero').css('z-index', 0);
                    if (null != n) {
                        $("#sayt-keywords").html("");
                        var a = "",
                            s = "",
                            o = 0,
                            r = 0;
                        a += '<ul id="leftlist" class="sayt-list" role="listbox">';
                        for (var l = 0; l < n.response.results.length; l++)
                            n.response.results[l].value,
                                0 == n.response.results[l].verticalKeys.length
                                    ? (o += 1) <= 5 &&
                                    (a += '<li class="sayt-list-element" role="option"><span class="component-a"><a href="' + $('#searchpath').html() + n.response.results[l].value + '">' + n.response.results[l].value + "</a></span></li>")
                                    : (r += 1) <= 5 &&
                                    (s += '<p class="sayt-list-element" role="option"><a href="' + $('#searchpath').html() + n.response.results[l].value + '" class="sayt-link">' + n.response.results[l].value + "</a></p>");
                        (a += "</ul>"), (a += "</div>");
                        var c = "";
                        (c += '<div id="sayt-list" role="listbox">'),
                            (c += s),
                            (c += "</div>"),
                            $("#sayt-keywords").html(a),
                            $("#sayt-links").html(c),
                            $("#sayt-keywords").show(),
                            $("#sayt-links").show(),
                            n.response.results.length > 0 ? $("#sayt-view").show() : $("#sayt-view").hide();
                    }
                },
            });
    });
    $('#search-button').click(function () {
        $('.page-navbar-top').addClass("search-active");
        $('#search-field').css("display", "block");
    })
    $('#clear-search').click(function () {
        $('.page-navbar-top').removeClass("search-active");
        $('#sayt-view').css("display", "none");
        $('#search-field').css("display", "none");
    })

    MobilePromoCorners();
    setTimeout(function () {

    }, 150);

});
$(window).resize(function () {
    MobilePromoCorners();
    setTimeout(function () {

    }, 1250);
});

function MobilePromoCorners() {
    if (window.innerWidth < 769) {
        $('.newpromowrapper').each(function () {
            if ($('.newpromowrapper').find('.firsthalf').hasClass('transparentBG')) {
                $(this).find('.secondhalf').addClass("override");
            }
        })
    };
}

function closeSearch() {
    setTimeout(function () {
        $("#search-input").focusout(function () {
            $('#sayt-view').css("display", "none");
            $('.page-navbar-top').removeClass("search-active");
            $('#search-field').css("display", "none");
        });
    }, 1000);
}